<template>
  <div class="schWrap">
    <van-field v-model="keyWord" label="" placeholder="请输入您要搜索的内容" @keydown.enter="searchFn">
      <template #button>
        <i class="iconfont icon-search" @click="searchFn"></i>
      </template>
    </van-field>
  </div>
</template>

<script>
import urlencode from "urlencode";

export default {
  name: "TopHeaderSearch",
  components: {},
  data() {
    return {
      keyWord: "",
    };
  },
  methods: {
    searchFn() {
      window.location.href = `/search.jsp?q=${urlencode(this.keyWord, "GBK")}`;
    },
  },
};
</script>

<style lang="scss">
.schWrap {
  width: 100%;
  height: 50px;
  background: #fff;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 199;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px 10px 0px 80px;
  display: flex;
  align-items: center;
  .van-cell {
    padding: 0px 16px;
    .van-field__control {
      font-size: 12px;
    }
    i {
      font-size: 14px;
      color: #df6250;
    }
  }
}
</style>
